import { Orientation } from '../../../constants/Orientation';
import { MediaType } from '../../../constants/MediaType';
import { and, anyPass, contains, find, not, propEq, values } from 'ramda';
import { Color } from '../../../constants/Color';
import { MainSource } from '../../../constants/Source';

const hasInOr = (value, array, defaultValue) => (array.indexOf(value) === -1 ? defaultValue : value);

// to keep consistency with publicmedia events
export const encodeBiType = (mediaType: MediaType): string => JSON.stringify({ id: mediaType, title: mediaType });

export const encodeBiCategory = (id: string, categories): string =>
  JSON.stringify({
    id,
    title: find<{ id: string; name: string }>(propEq('id', id), categories).name,
  });

export const encodeFolderId = ({
  mediaType = MediaType.Picture,
  color = Color.Any,
  orientation = Orientation.All,
  category = 'any',
}) => `${mediaType}_${orientation}_${category}_${color}`;

type TDecodeShutterstockFolderId = {
  mediaType: MediaType;
  color: Color;
  category: string;
  orientation: Orientation;
};

export const decodeShutterstockFolderId = (
  folderId: string,
  defaultMediaType = MediaType.Picture,
): TDecodeShutterstockFolderId => {
  const [mediaType, orientation = Orientation.All, category = 'any', color] = (folderId || '').split('_');
  const overriddenMediaType = mediaType || defaultMediaType;

  return {
    mediaType: hasInOr(overriddenMediaType, [MediaType.Video, MediaType.Picture], defaultMediaType),
    orientation: hasInOr(orientation, values(Orientation), Orientation.All),
    category,
    color: (color as Color) || Color.Any,
  };
};

export const hasShutterStockVideoMediaType = (tabsList: MainSource[], mediaTypes: MediaType[]) =>
  and(
    contains(MainSource.ShutterstockVideo, tabsList),
    anyPass([contains(MediaType.Video), contains(MediaType.SecureVideo)])(mediaTypes),
  );

export const hasShutterStockPictureMediaType = (tabsList: MainSource[], mediaTypes: MediaType[]) =>
  and(
    contains(MainSource.Shutterstock, tabsList),
    anyPass([contains(MediaType.Picture), contains(MediaType.SecurePicture)])(mediaTypes),
  );

export const getShutterstockDefaultMediaType = (tabsList: MainSource[], mediaTypes: MediaType[]) =>
  and(hasShutterStockVideoMediaType(tabsList, mediaTypes), not(hasShutterStockPictureMediaType(tabsList, mediaTypes)))
    ? MediaType.Video
    : MediaType.Picture;
